var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGettingReadyPageResultsCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_364_116179)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72 0H0V72H72V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.20117 36.3062C6.20117 52.782 19.5544 66.1398 36.0303 66.1398C52.5061 66.1398 65.8596 52.782 65.8596 36.3062H48.2411H23.8196H6.20117Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6866 66.1463C24.0408 66.1463 29.1919 60.9951 29.1919 54.6409C29.1919 48.2867 24.0408 43.1356 17.6866 43.1356C11.3324 43.1356 6.18164 48.2867 6.18164 54.6409C6.18164 60.9951 11.3324 66.1463 17.6866 66.1463Z",
    fill: "#9E007E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6944 52.8683C16.6671 52.8683 15.916 53.6634 15.916 54.6465C15.916 55.5964 16.6671 56.3918 17.6944 56.3918C18.7327 56.3918 19.4838 55.5964 19.4838 54.6465C19.4838 53.6634 18.7216 52.8683 17.6944 52.8683Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1104 55.2001L19.1328 54.2401H22.8002V55.2001H19.1104ZM17.2578 46.5601L18.2402 46.5577L18.2628 53.283L17.2802 53.2852L17.2578 46.5601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1255 24.0677H20.7598V12.7345C20.7598 10.9764 22.1845 9.55161 23.9426 9.55161C25.7008 9.55161 27.1255 10.9764 27.1255 12.7345V24.0677Z",
    fill: "#428DFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0664 9.55356C25.7591 9.55356 27.1308 10.9253 27.1308 12.618V59.3439H67.7234C67.7234 59.3439 67.7234 24.0262 67.7234 12.8814C67.7234 11.9987 67.3738 11.1524 66.7485 10.5286C66.1247 9.90329 65.2783 9.55356 64.3971 9.55356C54.1986 9.55356 24.0664 9.55356 24.0664 9.55356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.7235 59.3439C67.7235 59.3439 67.7235 24.0262 67.7235 12.8814C67.7235 11.9987 67.3738 11.1524 66.7485 10.5286C66.1247 9.90329 65.2783 9.55356 64.3972 9.55356C54.1987 9.55356 39.9062 9.55356 39.9062 9.55356",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9481 59.344H67.497L67.4985 12.8815C67.4985 12.4696 67.4167 12.0654 67.2622 11.6929C67.1078 11.3205 66.8808 10.9768 66.5901 10.6861C66.2994 10.3954 65.9557 10.1683 65.5832 10.0139C65.2108 9.85946 64.8065 9.77769 64.3962 9.77769H39.9053C39.7812 9.77769 39.6797 9.67777 39.6797 9.55362C39.6797 9.42947 39.7812 9.32806 39.9053 9.32806L64.3962 9.32954C64.8656 9.32954 65.3273 9.42345 65.7543 9.59908C66.1812 9.77622 66.5734 10.0366 66.9065 10.3697C67.2396 10.7028 67.5 11.0949 67.6771 11.5219C67.8528 11.9488 67.9467 12.4091 67.9467 12.8815L67.9481 59.344Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6493 18.6263C46.6493 20.0474 45.4975 21.2001 44.0762 21.2001H36.7039C35.2827 21.2001 34.1309 20.0474 34.1309 18.6263C34.1309 17.2045 35.2827 16.0525 36.7039 16.0525H44.0762C45.4975 16.0525 46.6493 17.2045 46.6493 18.6263Z",
    fill: "#9E007E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.5045 18.24H43.4395V18.96H61.5045V18.24Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.4405 27.12H34.5605V27.84H61.4405V27.12Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.6433 33.84H34.5605V34.56H51.6433V33.84Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7136 58.7654H50.6309V59.3414H67.7136V58.7654Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.7151 66.3431L54.2864 62.9009L60.0762 66.3431L58.2359 52.2377H50.5565L48.7151 66.3431Z",
    fill: "#428DFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.3972 54.9888C49.7507 54.9888 45.9839 51.2221 45.9839 46.5755C45.9839 41.929 49.7507 38.1622 54.3972 38.1622C59.0438 38.1622 62.8105 41.929 62.8105 46.5755C62.8105 51.2221 59.0438 54.9888 54.3972 54.9888Z",
    fill: "#428DFC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.572 55.3883V54.9373C55.2771 54.9385 55.9615 54.851 56.6143 54.6821C57.289 54.5094 57.9297 54.2505 58.5253 53.921L58.7441 54.3149C58.1144 54.6614 57.4374 54.9324 56.725 55.1148C56.0369 55.2923 55.316 55.3883 54.572 55.3883Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6241 47.2632L34.2168 46.856L34.9398 46.1331C35.7209 45.3514 36.9872 45.3514 37.7682 46.1331L38.1058 46.4704C38.8479 47.2122 40.0509 47.2122 40.793 46.4704C41.76 45.5037 43.3278 45.5037 44.2947 46.4704L43.8875 46.8776C43.1455 46.1357 41.9423 46.1357 41.2003 46.8776C40.2333 47.8449 38.6655 47.8449 37.6985 46.8776L37.3609 46.5403C36.8048 45.9841 35.9032 45.9841 35.3471 46.5403L34.6241 47.2632Z",
    fill: "#DFE1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.532 33.0367V30.0179H15.9267V21.6325H11.7896L6.19141 30.4999V33.0367H12.4896V36.4509H15.9267V33.0367H17.532ZM12.4896 25.4687V30.0179H9.77279L12.4896 25.4687Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9339 36.4509C27.1239 36.4509 29.1822 34.5164 29.1822 31.6969C29.1822 30.112 28.3794 28.9802 27.4122 28.4039C28.112 27.91 28.8323 26.922 28.8323 25.5636C28.8323 23.1558 26.9593 21.365 23.9545 21.365C20.9288 21.365 19.0764 23.1764 19.0764 25.5636C19.0764 26.922 19.797 27.91 20.4762 28.4039C19.5706 28.9596 18.7266 30.112 18.7266 31.6969C18.7266 34.537 20.723 36.4509 23.9339 36.4509ZM23.9545 30.1326C25.0247 30.1326 25.6011 30.812 25.6011 31.6351C25.6011 32.4994 25.0453 33.1169 23.9545 33.1169C22.884 33.1169 22.3079 32.4994 22.3079 31.6351C22.3079 30.812 22.9046 30.1326 23.9545 30.1326ZM23.9545 24.514C24.8601 24.514 25.354 25.0697 25.354 25.79C25.354 26.6134 24.7983 27.0867 23.9545 27.0867C23.1105 27.0867 22.5548 26.6134 22.5548 25.79C22.5548 25.0697 23.0283 24.514 23.9545 24.514Z",
    fill: "#151515"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_364_116179"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGettingReadyPageResultsCalendar);
export default __webpack_public_path__ + "static/media/gettingReadyPage--results__calendar.cfbb4457e7a39ffa364554d6fca982cd.svg";
export { ForwardRef as ReactComponent };